module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/consultas/consultas.component.css
// module id = ./src/app/components/consultas/consultas.component.css
// module chunks = main